import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { CwActionIcon, CwDivider } from '@bbraun/cortex-angular';
import { TranslateModule } from '@ngx-translate/core';
import { Sidebar, SidebarService } from '~/app/services/sidebar.service';

@Component({
  selector: 'gplus-sidebar-container',
  imports: [TranslateModule, CommonModule, CwDivider, CwActionIcon],
  templateUrl: './sidebar-container.component.html',
  styleUrl: './sidebar-container.component.scss',
  host: {
    '[class.open]': 'sidebar()?.open'
  }
})
export class SidebarContainerComponent {
  public sidebar = input<Sidebar>(null);

  constructor(private readonly sidebarService: SidebarService) {}

  public close() {
    this.sidebarService.close();
  }
}
